/*
 * Copyright (c) 2017 Datarista, Inc.
 */

/* eslint-disable consistent-return */

import { polyfill } from 'es6-promise';
import { List } from 'immutable';
import { startAction, completeAction, handleError, reportSuccess } from './common';
import { accountServiceClient } from '../utils/api';

polyfill();

export const actionTypes = {
  FETCH_PRICEBOOK_SUCCESS: 'FETCH_PRICEBOOK_SUCCESS',
  GET_REV_SHARE: 'GET_REV_SHARE',
  UPDATE_PRICE: 'UPDATE_PRICE',
  FETCH_ALL_SETTINGS: 'FETCH_ALL_SETTINGS',
};

// Connect to the API
const swaggerApi = accountServiceClient();

// Creates an update price action
const updatePriceSuccess = (updatedBucket, accountId) => ({
  type: actionTypes.UPDATE_PRICE,
  updatedBucket,
  accountId,
});

export function updatePrice(accountId, priceBucketId, priceInfo, token) {
  const actionText = 'Update Price';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.price_book
        .updatePriceBucket({
          Authorization: `bearer ${token}`,
          account_id: accountId,
          price_bucket_id: priceBucketId,
          body: {
            cost: priceInfo.cost,
            floor: priceInfo.floor,
          },
        })
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            const updateInfo = response.obj;
            reportSuccess(dispatch, 'Your price book has been updated!', null);
            dispatch(updatePriceSuccess(updateInfo, accountId));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Creates a rev share action
const receiveRevShare = (revShare, accountId) => ({
  type: actionTypes.GET_REV_SHARE,
  revShare,
  accountId,
});

// gets the revenue share value from account settings
export function getRevShare(accountId, token) {
  const actionText = 'Getting Rev Share Percentage';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.setting
        .getSetting({
          Authorization: `bearer ${token}`,
          account_id: accountId,
          setting_type: 'REV_SHARE',
        })
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            const revShareInfo = response.obj;
            dispatch(receiveRevShare(revShareInfo, accountId));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

// Create pricebook action
const receivePriceBook = (priceBook, accountId) => ({
  type: actionTypes.FETCH_PRICEBOOK_SUCCESS,
  priceBook,
  accountId,
});

// gets price book associated with an account
export function getPriceBook(accountId, token) {
  const actionText = 'Getting Price Book';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.price_book
        .getPriceBook({
          Authorization: `bearer ${token}`,
          account_id: accountId,
        })
        .then(response => {
          if (response.status >= 200 && response.status < 300) {
            const priceBookInfo = response.obj;
            dispatch(receivePriceBook(priceBookInfo, accountId));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

const fetchAccountPricingSettingsSuccess = settingsInfo => ({
  type: actionTypes.FETCH_ALL_SETTINGS,
  settingsInfo,
});

export function fetchAccountPricingSettings(token, accountId) {
  const actionText = 'fetching pricing settings for account';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.setting
        .getAll({
          Authorization: `bearer ${token}`,
          account_id: accountId,
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const settingsInfo = response.obj;
            dispatch(fetchAccountPricingSettingsSuccess(settingsInfo));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}

export function updateSettings(token, accountId, settingInfo) {
  const actionText = 'updating pricing settings for account';
  return dispatch => {
    startAction(dispatch, actionText);
    return swaggerApi.then(client => {
      client.setting
        .update({
          Authorization: `bearer ${token}`,
          account_id: accountId,
          body: {
            accountSettingType: settingInfo.accountSettingType,
            accountSettingValue: settingInfo.accountSettingValue,
            isDefault: settingInfo.isDefault,
          },
        })
        .then(response => {
          // If everything's cool, dispatch actions
          if (response.status >= 200 && response.status < 300) {
            const settingsInfo = response.obj;
            if (settingsInfo.accountSettingType === 'REV_SHARE') {
              dispatch(receiveRevShare(settingsInfo, accountId));
            }
            let settingsInfoList = new List();
            settingsInfoList = settingsInfoList.push(settingsInfo);
            dispatch(fetchAccountPricingSettingsSuccess(settingsInfoList));
            completeAction(dispatch, actionText);
          } else {
            return Promise.reject(response);
          }
        })
        .catch(err => {
          handleError(err, dispatch, actionText);
        });
    });
  };
}
